import React, { useState, useEffect, useLayoutEffect } from 'react'
import { connect } from "react-redux";

import {
    getFuelMileageReportData,
} from "../../../appRedux/actions/Fuel"
import {
    fetchResourceForLabel as getAssetData, getAssetDeviceRangeData, getAssetDeviceDailyFuelData
} from "../../../appRedux/actions/Asset"
import moment from 'moment';
import FuelConsumptionChart from './FuelConsumptionChart';
import FuelConsumptionRateChart from './FuelConsumptionRateChart';
import MovementChart from './MovementChart';
import IdealChart from './IdleChart';
import { Checkbox, Col, Row, Select } from 'antd';
import Widget from '../../../components/Widget';
import PeriodSelector from './PeriodSelector';
import { groupFuelDataByGroupingName, groupManualData } from '../../DeviceMap/fuel-report/fuelDataGroup';

const getValueByName = (array, name) => {
    const item = (array || []).find(obj => obj.name === name);
    return item ? item.value : 0; // Returns undefined if the item is not found
};

const mapStateToProps = ({ commonData, auth, asset, fuel }) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        mileage_report_data: fuel.mileage_report_data,
        assetData: asset.labelData,
        assetDeviceRangeData: asset.assetDeviceRangeData,
        assetDeviceDailyFuelData: asset.assetDeviceDailyFuelData,
        deviceDailyFuelDataLoading: asset.deviceDailyFuelDataLoading
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getFuelMileageReportData,
        getAssetData,
        getAssetDeviceRangeData,
        getAssetDeviceDailyFuelData
    }
}

function FuelChart(props) {

    const [fuelData, setFuelData] = useState([])
    const [assetId, setAssetId] = useState(null)
    const [data, setData] = useState([])
    const [assetData, setAssetData] = useState(null)
    const [chartUnit, setChartUnit] = useState()
    const [unit, setUnit] = useState()

    const [chartGroup, setChartGroup] = useState('7d')
    const [isCustomRange, setIsCustomRange] = useState(false)
    const [customRange, setCustomRange] = useState(null)
    const [startRange, setStartRange] = useState(null)
    const [endRange, setEndRange] = useState(null)

    const [idleFuelRate, setIdleFuelRate] = useState(0);
    const [standardFuelRate, setStandardFuelRate] = useState(null);

    const [assetLinkedDevice, setAssetLinkedDevice] = useState(null)
    const [deviceData, setDeviceData] = useState(null)
    const [isShowDeviceData, setIsShowDeviceData] = useState(false)

    const [selectedGroup, setSelectedGroup] = useState('d');

    const handleDataGroup = (group) => {
        setSelectedGroup(group)
    }

    const handleTaggleShowDeviceData = () => {
        setIsShowDeviceData(!isShowDeviceData)
    }

    useEffect(() => {
        // console.log(props);
        const asset = props.match.params.asset;
        if (asset) {
            // getMileageReportData(payload);
            setAssetId(asset)
            props.getAssetData(asset)
        }
    }, [])

    useEffect(() => {

        const duration = chartGroup;

        const now = moment(); //.subtract(1, 'days');
        let day = now.clone();
        let startRange = null;
        let endRange = null;
        // console.log('duration', duration);

        switch (duration) {
            case '1d': {
                startRange = now.clone().startOf('day').unix();
                endRange = now.clone().endOf('day').unix();
                break;
            }
            case '1m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(1, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '3m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(3, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '6m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(6, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '12m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(12, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '0': {
                if (customRange) {
                    endRange = customRange[1].unix();
                    startRange = customRange[0].unix();
                }
                break;
            }
            default: {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(6, 'days')
                startRange = day.clone().startOf('day').unix();
                break;
            }
        }
        if (endRange && startRange && assetData) {
            // console.log(startRange, endRange);
            // Convert unix timestamps to dates
            const periodFrom = moment.unix(startRange).toDate()
            const periodTo = moment.unix(endRange).toDate()
            // const periodFrom = moment(startDate);
            // const periodTo = moment(endDate);
            // console.log('periodFrom', periodFrom);
            // console.log('periodTo', periodTo);
            const payload = {
                "asset": assetData._id,
                "location": "all",
                "subLocation": "all",
                "periodFrom": periodFrom,
                "periodFromTs": startRange,
                "periodTo": periodTo,
                "periodToTs": endRange,
            }
            // console.log('Payload - ', payload);
            getMileageReportData(payload);
            setStartRange(startRange);
            setEndRange(endRange);
        }

    }, [chartGroup, isCustomRange, customRange, assetData])



    const getMileageReportData = (payload) => {
        props.getFuelMileageReportData(payload)
    }

    useEffect(() => {
        // console.log('props.mileage_report_data', props.mileage_report_data);
        if (props.mileage_report_data && props.mileage_report_data.length) {
            setFuelData(props.mileage_report_data[0][assetId])
            // setAssetData(props.mileage_report_data[0][assetId] && props.mileage_report_data[0][assetId][0] && props.mileage_report_data[0][assetId][0]['asset'])
        }
    }, [props.mileage_report_data, assetId])

    useEffect(() => {
        // console.log(props.assetData);
        if (props.assetData && props.assetData._id) {
            setAssetData(props.assetData)
            const deviceAsset = props.assetData.dependents && props.assetData.dependents.length && props.assetData.dependents.filter(dp => dp && dp.tagDeviceId)
            if (deviceAsset && deviceAsset[0]) {
                setAssetLinkedDevice(deviceAsset[0])
            }

            const idleRate = props.assetData.assetModel && props.assetData.assetModel.idealFuelConsumptionRate || 0;
            const standardRate = props.assetData.assetModel && props.assetData.assetModel.standardFuelConsumptionRate || [];
            setIdleFuelRate(idleRate)
            setStandardFuelRate(standardRate)
        }
    }, [props.assetData])

    // get IOt device data
    useEffect(() => {
        if (assetLinkedDevice && assetLinkedDevice.tagDeviceId && startRange && endRange) {

            props.getAssetDeviceDailyFuelData(assetId, assetLinkedDevice.tagDeviceId, startRange * 1000, endRange * 1000);
            // props.getAssetDeviceRangeData(assetId, assetLinkedDevice.tagDeviceId, startRange * 1000, endRange * 1000);
        }

    }, [assetLinkedDevice, startRange, endRange])

    useEffect(() => {
        // console.log(selectedGroup);
        if (props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data)
            setDeviceData((props.assetDeviceDailyFuelData.data || []).map(doc => {
                return {
                    ...doc,
                    date: moment(doc.date).format('DD-MM-YYYY')
                }
            }))
        // setFuelData(props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data || []);
        // else {
        //     groupFuelDataByGroupingName(props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data || [], selectedGroup)
        //         .then(docs => {
        //             setDeviceData(docs)
        //             // setGroupingLoading(false)
        //         })
        //         .catch(err => console.log(err))
        // }

    }, [props.assetDeviceDailyFuelData]);


    useLayoutEffect(() => {
        if (assetData) {
            const firstMeter = assetData && assetData.assetModel && assetData.assetModel.meters && assetData.assetModel.meters[0] && assetData.assetModel.meters[0]['name']
            // console.log(firstMeter);

            if (firstMeter)
                setUnit(firstMeter.toLowerCase())
        }
    }, [assetData])

    useEffect(() => {
        if (fuelData && fuelData.length && startRange && endRange) {
            // console.log('fuelData', fuelData)
            const meters = assetData && assetData.assetModel && assetData.assetModel.meters || []

            const groupedData = fuelData
                .filter(f => (moment(f.date).unix() >= startRange && moment(f.date).unix() <= endRange))
                .reduce((acc, row) => {

                    const formattedDate = moment(row.date).format('DD-MM-YYYY');
                    if (!acc[formattedDate]) {

                        const meterReadings = meters.reduce((readings, meter) => {
                            const meterName = meter.name.toLowerCase()
                            return {
                                ...readings,
                                [`${meterName}_reading`]: getValueByName(row.currentReading, meter.name),
                                [`${meterName}_consumed`]: 0,
                                [`${meterName}_qty`]: [],
                                [`qty_${meterName}`]: []
                            }
                        }, {})

                        acc[formattedDate] = {
                            quantity: 0,
                            isFullTank: false,
                            ...meterReadings
                        }
                    }

                    acc[formattedDate].quantity += row.quantity; //sum

                    // Update meter-specific values
                    meters.forEach(meter => {
                        const meterName = meter.name.toLowerCase()

                        // Add consumed readings
                        acc[formattedDate][`${meterName}_consumed`] += getValueByName(row.consumedReading, meter.name)

                        // Update current readings (take last value)
                        acc[formattedDate][`${meterName}_reading`] = getValueByName(row.currentReading, meter.name) ||
                            acc[formattedDate][`${meterName}_reading`]
                    })

                    acc[formattedDate].isFullTank = acc[formattedDate].isFullTank || row.isFullTank; // if previous date is full tank then current date is also full tank

                    return acc;
                }, {});

            // console.log(groupedData);

            // Convert the grouped data into the desired format
            const result = Object.entries(groupedData || {}).map(([date, values]) => {

                // Calculate dynamic meter ratios
                const meterRatios = meters.reduce((ratios, meter) => {
                    const meterName = meter.name.toLowerCase()
                    return {
                        ...ratios,
                        [`${meterName}_qty`]: values.quantity ?
                            Number((Number(values[`${meterName}_consumed`]) / Number(values.quantity)).toFixed(2)) : 0,
                        [`qty_${meterName}`]: values[`${meterName}_consumed`] ?
                            Number((Number(values.quantity) / Number(values[`${meterName}_consumed`])).toFixed(2)) : 0
                    }
                }, {})

                return {
                    date,
                    isFullTank: values.isFullTank,
                    quantity: values.quantity,
                    ...Object.keys(values)
                        .filter(key => key.endsWith('_reading') || key.endsWith('_consumed'))
                        .reduce((acc, key) => ({ ...acc, [key]: values[key] }), {}),
                    ...meterRatios
                }

            }).filter(item => item.isFullTank);

            // group d/w/m/y

            console.log('result', result);
            setData(result)
        }
    }, [fuelData]);

    const handleMasterUnitChage = (unit) => {
        setUnit(unit)
    }

    const processDataWithGroups = (data, selectedGroup) => {
        // console.log('data', data);
        const groupData = groupManualData(data, selectedGroup)
        // console.log('groupData', groupData);
        // acc[startOfPeriod].hours_qty = item.quantity ? Number(item.hours_consumed) / Number(item.quantity).toFixed(2) : 0;
        // acc[startOfPeriod].qty_hours = item.hours_consumed ? Number(item.quantity) / Number(item.hours_consumed).toFixed(2) : 0;
        // acc[startOfPeriod].kms_qty = item.quantity ? Number(item.kms_consumed) / Number(item.quantity).toFixed(2) : 0;
        // acc[startOfPeriod].qty_kms = item.kms_consumed ? Number(item.quantity) / Number(item.kms_consumed).toFixed(2) : 0;
        return Object.values(groupData)
    }

    useLayoutEffect(() => {
        // console.log(unit);

        setChartUnit(unit)
    }, [unit])

    const handleChartGroupChage = (group, isCustomRange, customRange) => {
        setChartGroup(group)
        if (isCustomRange) {
            setIsCustomRange(isCustomRange)
            setCustomRange(customRange)
        }
    }

    // console.log(chartUnit);


    return (
        <div>
            <Row>
                <Col sm={24} xs={24} lg={6}>
                    <Widget styleName="gx-card-full gx-dot-arrow-hover">
                        <div className="gx-media gx-align-items-center gx-flex-nowrap" style={{ minHeight: '110px' }}>
                            <div className="gx-px-3 gx-build-box-lay">
                                <img alt="..." src={require('assets/images/widget/fixed-asset.png')}
                                    className="" />
                            </div>
                            <div className="gx-media-body gx-py-3 gx-pr-4 gx-build-box-lay-content">
                                <h2
                                    className="h4 gx-text-truncate gx-mb-1">{assetData && assetData.assetCode || '-'} ({assetData && assetData.altName || '-'}) {assetData && assetData.ownerCode || '-'}</h2>
                                <p
                                    className="gx-mb-1 gx-text-black gx-fs-sm gx-mt-1">{assetData && assetData.assetModel && assetData.assetModel.name || '-'}</p>
                            </div>
                        </div>
                    </Widget>
                </Col>
                <Col sm={24} xs={24} lg={6}>
                    <Widget styleName="gx-card-full gx-dot-arrow-hover">
                        <div className="gx-media gx-align-items-center gx-flex-nowrap" style={{ minHeight: '110px' }}>
                            <div className="gx-px-3 gx-build-box-lay">
                                <img alt="..." src={require('assets/images/widget/location.png')}
                                    className="" />
                            </div>
                            <div className="gx-media-body gx-py-3 gx-pr-4 gx-build-box-lay-content">
                                <h2
                                    className="h4 gx-text-truncate gx-mb-1">{assetData && assetData.location && assetData.location.name || '-'}</h2>
                                <p
                                    className="gx-mb-1 gx-text-grey gx-fs-md gx-mt-1">{assetData && assetData.client && assetData.client.name || 'NA'}</p>
                            </div>
                        </div>
                    </Widget>
                </Col>
                <Col sm={24} xs={24} lg={6}>
                    <Widget styleName="gx-card-full gx-dot-arrow-hover">
                        <div className="gx-media gx-align-items-center gx-flex-nowrap" style={{ minHeight: '110px' }}>
                            <div className="gx-px-3 gx-build-box-lay">

                            </div>
                            <div className="gx-media-body gx-py-3 gx-pr-4 gx-build-box-lay-content">
                                <p
                                    className="gx-mb-1 gx-text-grey gx-fs-md gx-mt-1">Select Meter Unit</p>
                                <Select
                                    size='small'
                                    style={{ width: 200 }}
                                    placeholder="Select Meter Unit"
                                    onChange={handleMasterUnitChage}
                                    value={chartUnit}
                                >
                                    {
                                        (assetData && assetData.assetModel && assetData.assetModel.meters || []).map(m => <Select.Option key={m._id} value={m.name.toLowerCase()}>{m.name.toUpperCase()}</Select.Option>)
                                    }
                                </Select>
                                {assetLinkedDevice && assetLinkedDevice.tagDeviceId &&
                                    <Checkbox className='gx-mt-2' checked={isShowDeviceData} onClick={handleTaggleShowDeviceData}><small>Show IOT Data</small></Checkbox>
                                }
                            </div>
                        </div>
                    </Widget>
                </Col>
                <Col sm={24} xs={24} lg={6}>
                    <Widget styleName="gx-card-full gx-dot-arrow-hover">
                        <div className="gx-media gx-align-items-center gx-flex-nowrap" style={{ minHeight: `${chartGroup === '0' ? '120px' : '80px'}` }}>
                            <div className="gx-px-3 gx-build-box-lay">

                            </div>
                            <div className="gx-media-body gx-py-3 gx-pr-4 gx-build-box-lay-content">
                                <p
                                    className="gx-mb-1 gx-text-grey gx-fs-md gx-mt-1">Select time period</p>
                                <PeriodSelector handleChartGroupChage={handleChartGroupChage} chartGroup={chartGroup} selectedGroup={selectedGroup} handleDataGroup={handleDataGroup} />
                            </div>
                        </div>
                    </Widget>
                </Col>
            </Row>
            <FuelConsumptionChart assetData={assetData} data={data} loading={props.loading} selectedGroup={selectedGroup}
                chartUnit={chartUnit} processDataWithGroups={processDataWithGroups} />

            <FuelConsumptionRateChart assetData={assetData} data={data} loading={props.loading} selectedGroup={selectedGroup}
                idleFuelRate={idleFuelRate} standardFuelRate={standardFuelRate} chartUnit={chartUnit} processDataWithGroups={processDataWithGroups} />

            {
                isShowDeviceData && <IdealChart assetData={assetData} data={data} deviceData={deviceData}
                    isShowDeviceData={isShowDeviceData} loading={props.loading} selectedGroup={selectedGroup}
                    idleFuelRate={[]} standardFuelRate={[]} chartUnit={chartUnit} processDataWithGroups={processDataWithGroups} />
            }

            <MovementChart assetData={assetData} data={data} deviceData={deviceData} selectedGroup={selectedGroup}
                isShowDeviceData={isShowDeviceData} loading={props.loading} idleFuelRate={[]}
                standardFuelRate={[]} chartUnit={chartUnit} processDataWithGroups={processDataWithGroups} />

        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps())(FuelChart);